import { ReactNode, createContext, useContext } from 'react';

export interface ReferenceDetailsValue {
  showDetails: boolean;
  setShowDetails: (show: boolean) => void;
  viewLocale?: string;
}

const ReferenceDetailsContext = createContext<ReferenceDetailsValue | null>(null);

export const useReferenceDetails = () => {
  const context = useContext(ReferenceDetailsContext);
  if (!context) throw new Error('useReferenceDetails must be used inside ReferenceDetailsProvider');
  return context;
};

export const ReferenceDetailsProvider = ({ value, children }: { value: ReferenceDetailsValue; children: ReactNode }) => (
  <ReferenceDetailsContext.Provider value={value}>{children}</ReferenceDetailsContext.Provider>
);
